import React from 'react';
import styled, { css } from 'styled-components';

interface ButtonProps {
  className?: string;
  buttonType?: 'button' | 'submit';
  theme?: 'primary' | 'secondary';
  label: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

interface StyledButtonProps {
  $theme: 'primary' | 'secondary';
}

const StyledButton = styled.button<StyledButtonProps>`
  display: inline-flex;
  border-radius: var(--border-radius-m);
  padding: var(--distance-3xs) var(--distance-m);
  font-size: var(--font-size-xs);
  font-family: var(--font-family-camel);
  line-height: var(--line-height-xxs);
  box-sizing: border-box;
  cursor: pointer;
  text-align: center;

  ${({ $theme }) =>
    $theme === 'secondary' ? css`
      border: 1px solid var(--color-button-border-secondary);
      background-color: var(--color-button-background-secondary);
      color: var(--color-button-text-secondary);
    ` : css`
      border: 1px solid var(--color-button-border-primary);
      background-color: var(--color-button-background-primary);
      color: var(--color-button-text-primary);
    `
    }

  &:focus {
    ${({ $theme }) =>
    $theme === 'secondary' ? css`
      background-color: var(--color-button-background-focus-secondary);
      color: var(--color-button-text-secondary);
      border: 1px solid var(--color-button-border-focus-secondary);
      outline: 2px solid var(--color-button-outline-secondary);
    ` : css`
      background-color: var(--color-button-background-focus-primary);
      color: var(--color-button-text-primary);
      border: 1px solid var(--color-button-border-focus-primary);
      outline: 2px solid var(--color-button-outline-primary);
    `
    }
  }

  &:hover {
    ${({ $theme }) =>
    $theme === 'secondary' ? css`
      background-color: var(--color-button-background-hover-secondary);
      color: var(--color-button-text-secondary);
      border: 1px solid var(--color-button-border-hover-secondary);
    ` : css`
      background-color: var(--color-button-background-hover-primary);
      color: var(--color-button-text-primary);
      border: 1px solid var(--color-button-border-hover-primary);
    `
    }
  }
`;

const Button = ({ 
  className,
  buttonType = "button",
  theme = 'primary',
  label,
  onClick,
} : ButtonProps) => (
  <StyledButton $theme={theme} className={className} type={buttonType} onClick={onClick} >
    {label}
  </StyledButton>
);

export default Button;
